export default "__VITE_ASSET__6ab9d0f0__"